import React from 'react';
import { graphql } from 'gatsby';

import GallerySectionDS from 'design-system/src/components/organisms/GallerySection';
import { getImage } from '../../utils/media';

export default function GallerySection({ images, ...props }: any) {
    return (
        <GallerySectionDS
            {...props}
            images={images?.length ? images.map(getImage).filter(Boolean) : []}
        />
    );
}

export const query = graphql`
    fragment DatoCmsGallerySection on DatoCmsGallerySection {
        images {
            ...SourceMedia
            gatsbyImageData(
                width: 968
                height: 968
                imgixParams: { fit: "crop", w: "968", h: "968" }
                placeholder: BLURRED
            )
        }
    }
`;
